{
  "app": {
    "logoTitle": "MedCommit",
    "logoSubtitle": "Institutional Commitments",
    "description": "Application to track financial commitments made from schools to departments",
    "copyrightYear": "2026",
    "supportEmail": "medcommit@stanford.edu",
    "pageNotFound": {
      "title": "Page Not Found",
      "message": "The page you are trying to reach does not exist."
    }
  },
  "globals": {
    "form": {
      "actionButtons": {
        "save": "SAVE",
        "cancel": "CANCEL",
        "delete": "DELETE"
      },
      "fieldIsRequired": "{{fieldName}} is a required field",
      "valueAlreadyExists": "{{fieldName}} already used.  Please enter a unique {{fieldName}}"
    },
    "list": {
      "actionIcons": {
        "edit": {
          "tooltip": "Edit"
        }
      },
      "messages": {
        "noData": "No records to display",
        "fetchingInfo": "Loading ..."
      }
    },
    "accessDenied": {
      "title": "You do not have access to this page.",
      "description": "If you require access to it, please contact"
    },
    "tabUnderDevelopment": {
      "description": "This feature is under development."
    }
  },
  "PTAs": {
    "mainView": {
      "title": "PTAs",
      "list": {
        "tableColumns": {
          "pta": "PTA",
          "ptaStatus": "PTA Status",
          "taskStatus": "Task Status",
          "projectName": "Project Name",
          "taskName": "Task Name",
          "projectOrg": "Project Org",
          "projectOwner": "Project Owner",
          "taskOrg": "Task Org",
          "taskOwner": "Task Owner",
          "actions": "Actions"
        },
        "dataLoadingText": "Loading ...",
        "actionsColToolTip": "View PTA Details"
      }
    },
    "detailsView": {
      "title": "PTA Details",
      "goBackButtonLabel": "BACK",
      "tableLabels": {
        "project": "Project",
        "task": "Task",
        "award": "Award",
        "number": "Number",
        "name": "Name",
        "startDate": "Start Date",
        "endDate": "End Date",
        "org": "Org",
        "orgCodeName": "Org Code Name",
        "ownerFullName": "Owner Full Name",
        "managerFullName": "Manager Full Name"
      }
    },
    "filterPanelItems": {
      "title": "Filters",
      "options": {
        "project": {
          "label": "Project"
        },
        "task": {
          "label": "Task"
        },
        "award": {
          "label": "Award"
        },
        "projectName": {
          "label": "Project Name"
        },
        "projectOwner": {
          "label": "Project Owner"
        },
        "taskOwner": {
          "label": "Task Owner"
        }
      },
      "resetFilterText": "Reset All Filters"
    }
  },
  "Orgs": {
    "mainView": {
      "title": "Orgs"
    },
    "filterPanelItems": {
      "title": "Filters",
      "options": {
        "unit": {
          "label": "Unit"
        },
        "org": {
          "label": "Org"
        },
        "status": {
          "label": "Status"
        }
      },
      "resetFilterText": "Reset All Filters"
    }
  },
  "Commitments": {
    "mainView": {
      "title": "Commitments",
      "ctaTextForCreateCommitment": "CREATE COMMITMENT",
      "ctaTextForLinkToPTARequestForm": "LINK TO PTA REQUEST FORM",
      "list": {
        "tableColumns": {
          "status": "Status",
          "docs": "Docs",
          "commitmentName": "Commitment Name",
          "placeholder": "Placeholder",
          "departmentName": "Department Name",
          "memo": "Memo",
          "outstandingAmount": "Outstanding",
          "actions": "Actions"
        },
        "tableValues": {
          "statusOpenText": "Open",
          "statusClosedText": "Closed"
        },
        "dataLoadingText": "Loading ...",
        "editCommitmentsTooltip": "Edit Commitment",
        "viewDocumentsTooltip": "View Docs",
        "addComponentTooltip": "Add Component",
        "viewCommitmentsTooltip": "View Details"
      }
    },
    "create": {
      "title": "New Commitment",
      "breadcrumbTitle": "Create Commitment",
      "documentCount": "Document(s) Attached",
      "form": {
        "fields": {
          "commitmentName": {
            "label": "Commitment Name",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Commitment Name is required",
              "isDuplicate": "Commitment Name already used. Please enter a unique Commitment Name"
            }
          },
          "departmentName": {
            "label": "Department Name",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Department Name is required"
            }
          },
          "departmentCode": {
            "label": "Department Code",
            "placeHolder": ""
          },
          "commitmentType": {
            "label": "Commitment Type",
            "placeHolder": "",
            "regularOptionValue": "Regular",
            "placeholderOptionValue": "Placeholder",
            "memoOptionValue": "Memo",
            "requestOptionValue": "Request",
            "deferredOptionValue": "Deferred"
          },
          "memoAmount": {
            "label": "Memo Amount",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Memo Amount is required"
            }
          },
          "projectGroup": {
            "label": "Project Group",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Project Group is required"
            }
          },
          "commitmentUnit": {
            "label": "Unit",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Unit is required"
            }
          },
          "program": {
            "label": "Program",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Program is required"
            }
          },
          "presentation": {
            "label": "Presentation",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Presentation is required"
            }
          },
          "presentationSubCategory": {
            "label": "Presentation Sub Category",
            "placeHolder": ""
          },
          "commitmentNotes": {
            "label": "Commitment Notes",
            "placeHolder": ""
          },
          "closed": {
            "label": "Closed",
            "placeHolder": ""
          },
          "withdrawn": {
            "label": "Withdrawn"
          },
          "closedDate": {
            "label": "Closed Date",
            "validation": {
              "isEmpty": "Closed Date is required",
              "invalidDate": "Closed Date is Invalid. Please enter a valid date"
            }
          },
          "closedNotes": {
            "label": "Closed Notes",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Closed Notes is required"
            }
          },
          "coInvestmentEntity": {
            "label": "Co-Investment Entity",
            "validation": {
              "isEmpty": "Co-Investment Entity is required"
            }
          },
          "isRecruitment": {
            "label": "Is this for a recruitment?"
          }
        }
      },
      "notification": {
        "success": "Commitment {{commitmentName}} created.",
        "failed": "Failed to create Commitment {{commitmentName}}. Please try again later.",
        "update": "Commitment {{commitmentName}} updated."
      },
      "recruitment": {
        "dialogText": "You will need to download the New Hire Template excel sheet, fill in the necessary data, then upload the completed excel file.  After saving this page, the upload 'paper clip' can be found on the Budget main tab by clicking the 'paper clip' icon located at the right of the screen under the Actions column. Each new recruitment will have it's own 'paper clip' associated with that commitment.",
        "templateDownloadTooltip": "New Hire Template excel sheet",
        "continue": "Continue"
      }
    },
    "createRequest": {
      "title": "New Commitment Request",
      "breadcrumbTitle": "New Commitment Request"
    },
    "edit": {
      "title": "Edit Commitment",
      "breadcrumbTitle": "Edit Commitment"
    },
    "editRequest": {
      "title": "Edit Commitment Request",
      "breadcrumbTitle": "Edit Commitment Request",
      "complete": {
        "title": "Finalize Commitment \u201C{{commitmentName}}\u201D",
        "componentTitle": "Components",
        "enabledButtonTitle": "Finalize Commitment",
        "disabledButtonTitle": "Disposition the remaining components to finalize this commitment",
        "disabledButtonIsPublishedTitle": "This commitment has been published",
        "tableColumns": {
          "componentName": "Component Name",
          "componentDescription": "Component Description",
          "approvedAmount": "Approved Amount"
        }
      }
    },
    "view": {
      "breadcrumbTitle": "View Commitment",
      "title": "View Commitment",
      "goBackButtonLabel": "BACK"
    },
    "viewRequest": {
      "title": "View Commitment Request",
      "breadcrumbTitle": "View Commitment Request"
    },
    "delete": {
      "notification": {
        "success": "Commitment was successfully deleted.",
        "failed": "Failed to delete Commitment. Please try again later."
      }
    },
    "deleteRequest": {
      "title": "Delete Commitment Request",
      "breadcrumbTitle": "Delete Commitment Request"
    },
    "filterPanelItems": {
      "title": "Filters",
      "options": {
        "budgetYear": {
          "label": "Budget Year"
        },
        "commitmentName": {
          "label": "Commitment Name"
        },
        "departmentName": {
          "label": "Department Name"
        },
        "status": {
          "label": "Status"
        },
        "statusDropdownValues": {
          "statusActiveDropdownValue": "Open",
          "statusInactiveDropdownValue": "Closed"
        },
        "dispositionStatus": {
          "label": "Disposition Status"
        }
      },
      "resetFilterText": "Reset All Filters"
    },
    "commitmentDocuments": {
      "mainView": {
        "title": "Documents for",
        "documentsBreadCrumbLink": "Documents",
        "textForAddDocumentButton": "ADD DOCUMENT",
        "addNewHireTemplate": "Upload Completed New Hire Template",
        "viewNewHireTemplate": "Download Completed New Hire Template",
        "view": {
          "breadcrumbTitle": "View Documents"
        },
        "list": {
          "tableColumns": {
            "type": "Type",
            "detail": "Detail",
            "fileName": "File Name",
            "uploadedDate": "Uploaded",
            "uploadedBy": "Uploaded By",
            "adminView": "Dept View",
            "actions": "Actions"
          },
          "messages": {
            "noData": "No documents to display"
          },
          "editCommitmentDocumentsTooltip": "Edit Document",
          "deleteCommitmentDocumentsTooltip": "Delete Document",
          "documentNotesTitle": "Document Notes",
          "downloadCommitmentDocumentsTooltip": "Download"
        }
      },
      "create": {
        "title": "Add Document for ",
        "newHireTemplate": "Add New Hire Template for",
        "breadcrumbTitle": "Add Document",
        "form": {
          "fields": {
            "documentType": {
              "label": "Document Type",
              "placeHolder": "",
              "offerLetterOptionValue": "Offer Letter",
              "emailOptionValue": "Email",
              "recruitmentOptionValue": "Recruitment",
              "otherOptionValue": "Other",
              "validation": {
                "isEmpty": "Document Type is required."
              }
            },
            "documentName": {
              "label": "Document Details",
              "placeHolder": "",
              "validation": {
                "isEmpty": "Document Details is required."
              }
            },
            "documentNotes": {
              "label": "Document Notes",
              "placeHolder": "",
              "validation": {
                "isEmpty": "Document Notes is required."
              }
            },
            "uploadedDocument": {
              "label": "Drag 'n' Drop a file here, or Click to Select file. \n(Only .pdf,.docx,.xlsx,.png,.giff,.jpeg,.jpg,.msg file types will be accepted.)",
              "label2": "Drag 'n' Drop a file here, or Click to Select file. \n(Only {{extensionList}} file types will be accepted.)",
              "placeHolder": "",
              "validation": {
                "isDuplicate": "Document name already exists for this commitment. Please try with different name."
              }
            },
            "departmentAdminView": {
              "label": "Department Admin View",
              "placeHolder": ""
            }
          }
        },
        "notification": {
          "success": "Document {{documentName}} added.",
          "failed": "Failed to add Document {{documentName}}. Please try again later."
        }
      },
      "edit": {
        "breadcrumbTitle": "Edit Document",
        "title": "Edit Document for ",
        "newHireTemplate": "Edit New Hire Template for",
        "notification": {
          "success": "Document {{documentName}} updated.",
          "failed": "Failed to update Document {{documentName}}. Please try again later."
        }
      },
      "delete": {
        "dialog": {
          "title": "Delete Document",
          "content": "Are you sure you want to delete the document {{documentName}}? This action cannot be undone.",
          "cancelButton": "CANCEL",
          "deleteButton": "DELETE"
        },
        "notification": {
          "success": "Document deleted."
        }
      }
    },
    "commitmentComponents": {
      "mainView": {
        "list": {
          "tableColumns": {
            "pta": "PTA",
            "componentName": "Component Name",
            "date": "Date",
            "description": "Description",
            "unspentAmount": "Unspent Amount",
            "status": "Status",
            "actions": "Actions"
          },
          "tableValues": {
            "statusOpenText": "Open",
            "statusClosedText": "Closed",
            "statusClosedWithdrawnText": "Closed/Withdrawn"
          },
          "editCommitmentComponentsTooltip": "Edit Component",
          "viewComponentsTooltip": "View Details",
          "moveComponentTooltip": "Move Component",
          "financialHistoryTooltip": "History",
          "componentWarningPopOver": {
            "warningLabel": "Warnings"
          },
          "budgetTableHeaders": {
            "componentName": "Component Name",
            "amount": "Requested Amount",
            "fyBudget": "FY{{yearAbbv}} Budget",
            "fyPlanOne": "FY{{yearAbbv}} Plan",
            "fyPlanTwo": "FY{{yearAbbv}} Plan",
            "fyProjectionOne": "FY{{yearAbbv}} Projection",
            "startDate": "Start Date",
            "endDate": "End Date",
            "requestComments": "Request Comments",
            "actions": "Actions"
          },
          "budgetTableFooters": {
            "commitTotal": "Commit Total"
          }
        }
      },
      "create": {
        "title": "New Component for {{commitmentName}}",
        "breadcrumbTitle": "Create Component",
        "form": {
          "fields": {
            "unspentComponent": {
              "label": "Unspent Component"
            },
            "totalComponent": {
              "label": "Total Component"
            },
            "addComponent": {
              "label": "Add incremental component date and amount"
            },
            "addComponentMaxLimit": {
              "label": "Add incremental component date and amount reached max limit of 10"
            },
            "deleteComponent": {
              "label": "Delete incremental component date and amount"
            },
            "componentName": {
              "label": "Component Name",
              "validation": {
                "isEmpty": "Component Name is required",
                "isDuplicate": "Component Name already used for this commitment. Please enter a unique Component Name."
              }
            },
            "componentDescription": {
              "label": "Component Description",
              "validation": {
                "isEmpty": "Component Description is required"
              }
            },
            "componentDate": {
              "label": "Component Date",
              "validation": {
                "isEmpty": "Component Date is required",
                "invalidDate": "Component Date is Invalid. Please enter a valid date",
                "minDateMessage": "Component Date should be greater than the previous one"
              }
            },
            "totalComponentAmount": {
              "label": "Component Amount",
              "validation": {
                "isEmpty": "Component Amount is required"
              }
            },
            "totalComponentAmountRequested": {
              "label": "Requested Component Amount"
            },
            "totalComponentAmountApproved": {
              "label": "Approved Component Amount"
            },
            "project": {
              "label": "Project"
            },
            "task": {
              "label": "Task"
            },
            "award": {
              "label": "Award"
            },
            "taskName": {
              "label": "Task Name"
            },
            "piOrComponentOwner": {
              "label": "PI/Component Owner"
            },
            "componentType": {
              "label": "Component Type",
              "bridgeFunding": "Bridge Funding",
              "dc": "DC",
              "gradStudentSupport": "Grad Student Support",
              "housingOptionValue": "Housing",
              "mcdBackstop": "MCD Backstop",
              "mockEndowment": "Mock Endowment",
              "renovation": "Renovation",
              "seedGrants": "Seed Grants",
              "subsidy": "Subsidy",
              "request": "Component Requests",
              "deanCommitment": "Dean's Commitments"
            },
            "purpose1": {
              "label": "Purpose 1"
            },
            "purpose2": {
              "label": "Purpose 2"
            },
            "expenditureRestrictions": {
              "label": "Expenditure Restrictions",
              "validation": {
                "maxExpenditures": "Component cannot have more than 5 expenditures."
              }
            },
            "startDate": {
              "label": "Start Date",
              "validation": {
                "maxDateMessage": "Date cannot be same as or after Expiration Date",
                "invalidDate": "Start Date is Invalid. Please enter a valid date"
              }
            },
            "expirationDate": {
              "label": "Expiration Date",
              "validation": {
                "minDateMessage": "Date cannot be same as or before Start Date",
                "invalidDate": "Expiration Date is Invalid. Please enter a valid date"
              }
            },
            "durationNotes": {
              "label": "Duration Notes"
            },
            "closed": {
              "label": "Closed"
            },
            "closedDate": {
              "label": "Closed Date",
              "validation": {
                "isEmpty": "Closed Date is required",
                "invalidDate": "Closed Date is Invalid. Please enter a valid date"
              }
            },
            "closedDetails": {
              "label": "Closed Details",
              "validation": {
                "isEmpty": "Closed Details are required"
              }
            },
            "recordNumber": {
              "label": "Record Number"
            },
            "componentNotes": {
              "label": "Component Request Notes"
            }
          },
          "fieldDataLoadingText": "Loading data ..."
        },
        "notification": {
          "success": "Component {{componentName}} for Commitment {{commitmentName}} created.",
          "failure": "Failed to create Component {{componentName}}. Please try again later."
        },
        "ptaDetails": {
          "name": "Name",
          "startDate": "Start Date",
          "endDate": "End Date",
          "org": "Org",
          "ownerFullName": "Owner Full Name",
          "managerFullName": "Manager Full Name"
        },
        "changePIOrComponentOwnerPopup": {
          "title": "Change PI/Component Owner?",
          "message": "Task Owner \"{{taskOwnerName}}\" is different than Component Owner \"{{componentOwnerName}}\". \n\nChange current PI/Component Owner \"{{componentOwnerName}}\" to the Task Owner Name \"{{taskOwnerName}}\"?",
          "okLabel": "CHANGE",
          "cancelLabel": "DON'T CHANGE"
        }
      },
      "createRequest": {
        "title": "New Component Request for {{commitmentName}}",
        "breadcrumbTitle": "New Component Request"
      },
      "edit": {
        "title": "Edit Component for {{commitmentName}}",
        "breadcrumbTitle": "Edit Component",
        "notification": {
          "success": "Component {{componentName}} for Commitment {{commitmentName}} updated.",
          "failed": "Failed to update Component {{componentName}}. Please try again later."
        }
      },
      "editRequest": {
        "title": "Edit Component Request for {{commitmentName}}",
        "breadcrumbTitle": "Edit Component Request"
      },
      "view": {
        "breadcrumbTitle": "View Component",
        "title": "View Component for {{commitmentName}}",
        "goBackButtonLabel": "BACK"
      },
      "viewRequest": {
        "title": "View Component Request for {{commitmentName}}",
        "breadcrumbTitle": "View Component Request"
      },
      "delete": {
        "notification": {
          "success": "Component was successfully deleted.",
          "failed": "Failed to delete Component. Please try again later."
        }
      },
      "deleteRequest": {
        "title": "Delete Component Request for {{commitmentName}}",
        "breadcrumbTitle": "Delete Component Request"
      },
      "dispositionTypes": {
        "requested": "Requested",
        "approved": "Approved",
        "defer": "Deferred",
        "notApproved": "Not Approved"
      }
    },
    "moveComponent": {
      "title": "Move and Close Component",
      "currentCommitment": "Current Commitment",
      "currentDepartment": "Current Department",
      "newCommitment": "New Commitment",
      "newDepartment": "New Department",
      "componentName": "Component Name",
      "componentDate": "Component Date",
      "componentType": "Component Type",
      "pta": "PTA",
      "unspentAmount": "Unspent Amount",
      "componentAmount": "Component Amount",
      "noData": "No records to display",
      "noOptionsText": "Please type a name to search",
      "movedComponentName": "{{componentName}}-MOVED",
      "movedTaskName": "{{taskName}}-MOVED",
      "helpText": "With this feature, a component can be moved from its current commitment to another commitment.  After it’s moved, the original component would be closed and the unspent amount will carry forward to the moved-to component.",
      "successMessage": "Successfully moved the component",
      "duplicateComponentErrorMessage": "Another component exists with the same name. Please rename it before continuing the Move operation.",
      "movedStatusComponent": "Moved from: <Link>{{componentName}}</Link> on {{moveDate}} by {{moveBy}}",
      "originalStatusComponent": "Moved to: <Link>{{componentName}}</Link> on {{moveDate}} by {{moveBy}}"
    },
    "financialHistory": {
      "mainView": {
        "title": "Financial History",
        "addFiscalYearBtn": "ADD FISCAL YEAR",
        "financialHistoryDetails": {
          "componentAmount": "Component Amount",
          "projectTaskAward": "Project-Task-Award"
        },
        "list": {
          "fiscalYearTable": {
            "tableColumns": {
              "actuals": "ACTUALS",
              "planning": "PLANNING",
              "fiscalYear": "Fiscal Year",
              "fytdExpenseAmt": "FYTD Expense Amt.",
              "fytdTransferAmt": "FYTD Transfer Amt.",
              "fytdActualAmt": "FYTD Actual Amt.",
              "fySpendCap": "FY Spend Cap",
              "budgetAmt": "Budget Amt.",
              "planAmt": "Plan Amt.",
              "lrff": "LRFF",
              "yepAmt": "YEP Amt.",
              "actions": "Actions"
            },
            "editFiscalYearTooltip": "Edit FY",
            "addTransactionTooltip": "Add Transaction"
          },
          "glPeriodTable": {
            "tableColumns": {
              "glPeriod": "GL Period",
              "mtdExpenses": "MTD Expenses",
              "mtdTransfers": "MTD Transfers",
              "mtdActuals": "MTD Actuals"
            },
            "manualTransactionEntryDetails": {
              "entryLabel": "Entry",
              "enteredByLabel": "Entered by",
              "onLabel": "on"
            }
          },
          "noFinancialHistoryMsg": "No Financial History is available."
        },
        "goBackButtonLabel": "BACK",
        "andPriorSuffix": " & Prior"
      },
      "create": {
        "title": "Add Financial History for Fiscal Year {{fiscalYear}}",
        "breadcrumbTitle": "Add Fiscal Year",
        "form": {
          "fields": {
            "budgetAmount": {
              "label": "Budget Amount"
            },
            "planAmount": {
              "label": "Plan Amount"
            },
            "longRangeFinancialForecast": {
              "label": "Long Range Financial Forecast"
            },
            "yepAmount": {
              "label": "YEP Amount"
            },
            "fySpendCap": {
              "label": "FY Spend Cap"
            }
          }
        },
        "notification": {
          "success": "Fiscal Year {{fiscalYear}} added.",
          "failure": "Failed to add Fiscal Year {{fiscalYear}}."
        }
      },
      "edit": {
        "breadcrumbTitle": "Edit Fiscal Year",
        "title": "Edit Financial History for Fiscal Year {{fiscalYear}}",
        "notification": {
          "success": "Fiscal Year {{fiscalYear}} updated.",
          "failure": "Failed to update Fiscal Year {{fiscalYear}}."
        }
      },
      "financialTransaction": {
        "create": {
          "title": "Add Financial Transaction for Fiscal Year {{fiscalYear}}",
          "breadcrumbTitle": "Add Financial Transaction",
          "form": {
            "fields": {
              "type": {
                "label": "Type"
              },
              "glPeriod": {
                "label": "GL Period"
              },
              "amount": {
                "label": "Amount"
              },
              "note": {
                "label": "Note"
              }
            }
          },
          "transactionTypes": {
            "expenses": "Expense",
            "transfers": "Transfer"
          },
          "notification": {
            "success": "Financial Transaction for {{periodEntryNumber}} added."
          }
        }
      }
    }
  },
  "UploadedExpenses": {
    "filterPanelItems": {
      "title": "Filters",
      "options": {
        "fiscalYear": {
          "label": "Fiscal Year"
        },
        "glPeriod": {
          "label": "GL Period"
        },
        "posted": {
          "label": "Posted"
        },
        "conditionType": {
          "label": "Condition Type"
        },
        "notification": {
          "label": "Notification"
        },
        "postedDropdownValues": {
          "posted": "Posted",
          "unPosted": "Unposted"
        },
        "conditionTypeDropdownValues": {
          "error": "Error",
          "warning": "Warning",
          "redistributed": "Redistributed"
        },
        "notificationDropdownValues": {
          "unprocessed": "Unresolved",
          "inProcess": "In Process",
          "resolved": "Resolved"
        }
      }
    },
    "mainView": {
      "title": "Expenses",
      "subTitle": "Last Upload GL Period: {{glPeriod}}",
      "list": {
        "tableColumns": {
          "glPeriod": "GL Period",
          "commitmentName": "Commitment Name",
          "componentName": "Component Name",
          "pta": "PTA",
          "expenditureCategory": "Expenditure Category",
          "mtdAmount": "MTD Amount",
          "errorWarnings": "Warning/Error Condition",
          "actions": "Actions"
        },
        "editNotificationToolTip": "Update Notification",
        "revalidateAndPostToolTip": "Validate & Post",
        "redistributeToolTip": "Redistribute",
        "errorToolTip": "Error",
        "warningToolTip": "Warning",
        "redistributedToolTip": "Expense Redistribution Details",
        "notificationStatusTooltip": {
          "by": "by",
          "on": "on"
        },
        "redistributeExpensesDialog": {
          "title": "Redistribute Expenses",
          "tableColumns": {
            "montlyExpenseDetail": {
              "glPeriod": "GL Period",
              "pta": "PTA",
              "expenditureCategory": "Expenditure Category",
              "mtdAmount": "MTD Amount",
              "source": "SOURCE",
              "sourceGlPeriod": "Source GL Period"
            },
            "componentDetail": {
              "commitmentName": "Commitment Name",
              "componentName": "Component Name",
              "pta": "PTA",
              "redistributedAmount": "Redistributed Amount",
              "destination": "DESTINATION"
            }
          },
          "remainingToDistribute": "Remaining to redistribute",
          "noComponentsMessage": "No Components contain the award and project.",
          "closebutton": {
            "label": "CLOSE"
          }
        },
        "notificationStatusDialog": {
          "title": "Change Notification Status",
          "fields": {
            "notificationStatus": {
              "label": "Notification Status",
              "listOfValues": {
                "unresolved": "Unresolved",
                "inProcess": "In Process",
                "resolved": "Resolved"
              }
            },
            "notes": {
              "label": "Notes"
            }
          },
          "actionButtons": {
            "change": {
              "label": "CHANGE"
            },
            "dontChange": {
              "label": "DON'T CHANGE"
            }
          }
        }
      },
      "revalidateAndPost": {
        "postedWithoutWarnings": "Posted without warnings.",
        "notPosted": "Not Posted",
        "postedWithWarning": "Posted with Warnings."
      },
      "redistributed": {
        "redistributedWithoutWarnings": "Redistributed without warnings.",
        "redistributedWithWarning": "Redistributed with Warnings."
      }
    }
  },
  "UploadedTransfers": {
    "filterPanelItems": {
      "title": "Filters",
      "options": {
        "fiscalYear": {
          "label": "Fiscal Year"
        },
        "glPeriod": {
          "label": "GL Period"
        },
        "posted": {
          "label": "Posted"
        },
        "conditionType": {
          "label": "Condition Type"
        },
        "notification": {
          "label": "Notification"
        },
        "journalSource": {
          "label": "Journal Sourece"
        },
        "postedDropdownValues": {
          "posted": "Posted",
          "unPosted": "Unposted"
        },
        "conditionTypeDropdownValues": {
          "error": "Error",
          "warning": "Warning",
          "redistributed": "Redistributed"
        },
        "notificationDropdownValues": {
          "unprocessed": "Unresolved",
          "inProcess": "In Process",
          "resolved": "Resolved"
        }
      }
    },
    "mainView": {
      "title": "Transfers",
      "subTitle": "Last Upload GL Period: {{glPeriod}}",
      "list": {
        "tableColumns": {
          "notification": "Notification",
          "fiscalYear": "Fiscal Year",
          "glPeriod": "GL Period",
          "commitmentName": "Commitment Name",
          "componentName": "Component Name",
          "pta": "PTA",
          "journalSource": "Journal Source",
          "journalName": "Journal Name",
          "transferType": "Transfer Type",
          "amount": "Amount",
          "posted": "Posted",
          "errorWarnings": "Warning/Error Condition",
          "actions": "Actions"
        },
        "unprocessed": "Unprocessed",
        "editNotificationToolTip": "Update Notification",
        "redistributeToolTip": "Redistribute",
        "errorToolTip": "Error",
        "warningToolTip": "Warning",
        "redistributedLabel": "Redistributed",
        "redistributedDetailsTooltip": "Transfer Redistribution Details",
        "transferTypeValues": {
          "transferIn": "Transfer In",
          "transferOut": "Transfer Out",
          "receipt": "Receipt"
        },
        "redistributeTransfersDialog": {
          "title": "Redistribute Transfers",
          "tableColumns": {
            "monthlyTransferDetail": {
              "glPeriod": "GL Period",
              "project": "Project",
              "award": "Award",
              "source": "Source",
              "journalName": "Journal Name",
              "deptReference": "Dept. Reference",
              "objectCode": "Object Code",
              "fyLastPeriod": "FY Last Period",
              "journalLineText": "Journal Line Descriptive Text"
            },
            "componentDetail": {
              "rec": "Rec",
              "commitmentName": "Commitment Name",
              "componentName": "Component Name",
              "pta": "PTA",
              "redistributedAmount": "Redistributed Amount"
            }
          },
          "remainingToDistribute": "Remaining to redistribute",
          "detailsPage": {
            "title": "Transfer Redistribution Details",
            "sourceLabel": "SOURCE",
            "redistributedAmount": "Redistributed Amount",
            "mtdAmount": "MTD Amount",
            "destinationLabel": "DESTINATION",
            "closeButtonText": "CLOSE"
          }
        }
      },
      "uploadTransfersButton": "Upload Transfers"
    },
    "uploadTransfersDialog": {
      "title": "Upload Monthly Transfers File",
      "fields": {
        "glPeriod": {
          "label": "GL Period"
        },
        "transferUploader": {
          "label": "Drag 'n' Drop a file here, or Click to Select file. \n(Only .xls, .xlsx file types will be accepted.)"
        }
      },
      "actionButtons": {
        "cancel": {
          "label": "CANCEL"
        },
        "upload": {
          "label": "UPLOAD"
        }
      },
      "advanceGLPeriod": {
        "ctaButtonText": "ADVANCE GL PERIOD",
        "confirmationDialog": {
          "title": "Advance Last Uploaded GL Period",
          "description": "Use this option only when there are no Transfers in the GL Period. This action cannot be reversed.",
          "confirmationText": "Are you sure you want to advance the Transfer Last GL Period uploaded to {{glPeriod}}?"
        },
        "actionButtons": {
          "yes": "YES",
          "no": "NO"
        }
      },
      "notification": {
        "invalidGLPeriod": "Not Processed - Upload GL Period is {{glPeriod}}",
        "invalidExcelColumns": "Not Processed - Incorrect Format",
        "someErrorOccurred": "Some error occurred"
      }
    }
  },
  "Budgeting": {
    "mainView": {
      "title": "Budgeting",
      "departmentNameDropdown": {
        "title": "Department Name"
      },
      "budgetTypeFilter": {
        "label": "Commitment Type",
        "options": {
          "all": "All Budget Types",
          "existing": "Existing Only",
          "new": "New Only"
        }
      },
      "newRequest": "New Commitment Request",
      "newHireRequest": "New Hire Commitment Request",
      "editRequest": "Edit Commitment Request",
      "deleteRequest": "Delete Commitment Request",
      "newComponent": "New Component Request",
      "editComponent": "Edit Component Request",
      "deleteComponent": "Delete Component Request",
      "informationPanel": {
        "budgetFiscalYear": "Budget Fiscal Year",
        "editStatus": "Edit Status",
        "initialEditPeriod": "Initial Edit Period",
        "revisionEditPeriod": "Revision Edit Period",
        "addBudgetFiscalYearToolTip": "Add Budget Fiscal Year",
        "editBudgetFiscalYearToolTip": "Edit Budget Fiscal Year"
      },
      "list": {
        "tableColumns": {
          "commitmentName": "Commitment Name",
          "totalCommitment": "Total Commitment",
          "fyActualsThree": "FY{{fyActualsThree}} Actuals",
          "fyActualsTwo": "FY{{fyActualsTwo}} Actuals",
          "fyActualsOne": "FY{{fyActualsOne}} Actuals \n Thru Feb",
          "unspentCommitments": "Unspent Commitments",
          "unspentCommitmentsAsOf": "Unspent Commitments \n as of {{unspentCommitmentsAsOfDate}}",
          "fyBudgetOne": "FY{{fyBudgetOne}} Budget",
          "fyProjection": "FY{{fyProjection}} Projection",
          "fyBudgetTwo": "FY{{fyBudgetTwo}} Budget",
          "fyPlanOne": "FY{{fyPlanOne}} Plan",
          "fyPlanTwo": "FY{{fyPlanTwo}} Plan",
          "availableAfter": "Available after FY{{availableAfter}}",
          "fyBudgetCap": "FY{{fyBudgetCap}} Budget Cap",
          "comments": "Comments",
          "grantTotal": "Grand Total",
          "actions": "Actions",
          "deansCommitments": "Dean's Commitments",
          "totalExpenditures": "Total Expenditures"
        },
        "unspentCommitmentInfoTooltip": "Unspent balance may include expenses from prior fiscal years not reflected in this report.",
        "editBudgetTooltip": "Edit Budget Amounts",
        "budgetUpdated": "Component Budget Updated."
      }
    },
    "createDialog": {
      "addTitle": "Add Budget Fiscal Year {{fiscalYear}}",
      "editTitle": "Edit Budget Fiscal Year {{fiscalYear}}",
      "form": {
        "fields": {
          "initialEditPeriod": {
            "label": "Initial Edit Period",
            "validation": {
              "maxDateMessage": "Date cannot be on or after the Initial Edit Period End Date.",
              "minDateMessage": "Date cannot be on or before the Initial Edit Period Start Date."
            }
          },
          "to": {
            "label": "to"
          },
          "revisionEditPeriod": {
            "label": "Revision Edit Period",
            "validation": {
              "maxDateMessage": "Date cannot be on or after the Revision Edit Period End Date.",
              "minDateMessage": "Date cannot be on or before the Revision Edit Period Start Date.",
              "revisionEditPeriodStartDateAfterInitialEndDate": "Revision Edit Period Start Date cannot be on or before the Initial Edit Period End Date."
            }
          },
          "fiscalYearDateRangeMessage": "Date should be within the Fiscal Year Range."
        }
      },
      "confirmationMessage": "Are you sure you want to add a Budget Fiscal Year? \nThis will change the current Budget Fiscal Year to {{fiscalYear}}.",
      "confirmationDialogActionButtons": {
        "addButton": "ADD"
      }
    }
  },
  "Requests": {
    "mainView": {
      "list": {
        "tableColumns": {
          "year": "Year",
          "dispositionStatus": "Disposition Status",
          "department": "Department",
          "commitmentName": "Commitment Name",
          "componentName": "Component Name",
          "totalCommitmentRequested": "Total Commitment Requested",
          "requested": "Requested",
          "totalCommitmentApproved": "Total Commitment Approved",
          "approved": "Approved",
          "totalFyProjection": "Total FY{{fyProjection}} Projection",
          "fyProjection": "FY{{fyProjection}} Projection",
          "totalFyBudget": "Total FY{{fyBudgetOne}} Budget",
          "fyBudget": "FY{{fyBudgetOne}} Budget",
          "controllerNotes": "Controller Notes",
          "controllerComments": "Controller Comments",
          "dispositionNotes": "Disposition Notes",
          "dispositionComments": "Disposition Comments",
          "requestNotes": "Request Notes",
          "actions": "Actions",
          "grandTotal": "Grand Total"
        },
        "editComponentTooltip": "Change Component Disposition",
        "editComponentDisabledTooltip": "This Component cannot be edited here",
        "editCommitmentTooltip": "Edit Commitment Notes/Comments",
        "editCommitmentDisabledTooltip": "This Commitment cannot be edited here"
      },
      "publishButtonText": "Publish Results",
      "exportButtonText": "Export",
      "publishConfirmDialog": {
        "title": "Publish Request Data",
        "message": "Are you sure you want to publish the current state of the data? This will finalize the data and make it visible to other users.",
        "okLabel": "Publish the Data"
      },
      "notYetPublishedWarning": "The {{budgetFiscalYear}} fiscal year Request dispositions have not been released yet. <br />Once finalized, they will appear here."
    },
    "inlineEdit": {
      "form": {
        "fields": {
          "dispositionStatus": {
            "label": "Disposition Status"
          },
          "totalComponentAmountApproved": {
            "validation": {
              "greaterThanZero": "Approved amount must be greater than 0"
            }
          }
        }
      }
    }
  },
  "TableauReporting": {
    "mainView": {
      "title": "Tableau Reporting",
      "text": "Access MedCommit Reports using ",
      "url": "https://tableau.stanford.edu/#/site/SOM/projects/1106"
    }
  },
  "Approved": "Approved",
  "Requested": "Requested",
  "Deferred": "Deferred",
  "Housing": "Housing",
  "Component Requests": "Component Requests",
  "Dean's Commitments": "Dean's Commitments",
  "Regular": "Regular",
  "Placeholder": "Placeholder",
  "Memo": "Memo"
}